import { BASE_URL, BUSINESS_NAME } from "@/core/constants/business";

export const META = {
  title: `Contact Us | ${BUSINESS_NAME} Cannabis Dispensary`,
  meta_description: `Get in touch with ${BUSINESS_NAME}, Washington DC's premier cannabis dispensary. Reach out with your questions about our products, locations, or services.`,
  canonicalUrl: "/contact",
  keywords: `${BUSINESS_NAME} contact, contact cannabis dispensary, marijuana shop contact, DC weed store, cannabis questions, contact form, Washington DC dispensary contact`,
};

export const generateContactRichSnippet = () => {
  return {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    url: `${BASE_URL}/contact`,
    mainEntity: {
      "@type": "Organization",
      name: BUSINESS_NAME,
      url: BASE_URL,
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "(202) 340-8277",
        contactType: "customer service",
        email: "info@streetlawyerservices.com",
        areaServed: "Washington DC",
        availableLanguage: ["English"],
      },
      address: {
        "@type": "PostalAddress",
        streetAddress: "3400 Connecticut Avenue NW",
        addressLocality: "Washington",
        addressRegion: "DC",
        postalCode: "20008",
        addressCountry: "US",
      },
      sameAs: [
        "https://www.instagram.com/streetlawyerservices/",
        "https://www.youtube.com/@streetlawyerpodcast",
      ],
    },
    speakable: {
      "@type": "SpeakableSpecification",
      cssSelector: ["h1", ".contact-intro", ".contact-details"],
    },
  };
};
